import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/modules/common';
import { Routes } from '@/router/routes';

import { useCreateOverlay } from '../api';
import { OverlayForm } from '../components';

export const NewOverlayPage: FC = () => {
  const navigate = useNavigate();

  const { createOverlayMutation, uploadUrlData, isFetching, refetchUploadUrl } =
    useCreateOverlay();

  const saveOverlay = async (data) => {
    if (uploadUrlData?.overlayId) {
      try {
        await createOverlayMutation.mutateAsync({
          ...data,
          id: uploadUrlData.overlayId,
        });
        navigate(Routes.Overlays, { replace: true });
        toast.success(`Overlay “${data.name}” added successfully!`);
      } catch (error) {
        console.error(error.message);
      }
    }
  };

  const refetchUploadCredentials = async () => {
    try {
      await refetchUploadUrl();
    } catch (error) {
      toast.error('Uh oh! Something went wrong.');
    }
  };

  return (
    <OverlayForm
      onSubmit={saveOverlay}
      uploadUrlData={uploadUrlData}
      refetchUploadCredentials={refetchUploadCredentials}
    >
      {({ isLoading }) => (
        <PageHeader
          title="New Overlay"
          asChildPage
          backPath={Routes.Overlays}
          actions={[
            <Button
              key="create-overlay"
              type="submit"
              data-testid="create-overlay-button"
              isLoading={
                isFetching || createOverlayMutation.isPending || isLoading
              }
              startIcon={<PlusSquareIcon />}
            >
              Create new overlay
            </Button>,
          ]}
        />
      )}
    </OverlayForm>
  );
};
